import { createBrowserRouter as createBrowserRouterReact } from 'react-router-dom';
import { createBrowserRouter as createBrowserRouterRUM } from '@datadog/browser-rum-react/react-router-v6';
import { reactPlugin } from '@datadog/browser-rum-react';

import type { IDatadog } from './types';

import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum';

class DatadogRUM {
    private sessionSampleRate: number;
    private replaySampleRate: number;
    private replayDefaultMasking: DefaultPrivacyLevel;
    private supportReactRouter: boolean;

    private isInited: boolean;

    constructor() {
        this.sessionSampleRate = 20;
        this.replaySampleRate = 0;
        this.replayDefaultMasking = DefaultPrivacyLevel.MASK;
        this.supportReactRouter = true;

        this.isInited = false;
    }

    init(config: IDatadog) {
        if (this.isInited) return;

        this.sessionSampleRate = config.sessionSampleRate ?? this.sessionSampleRate;
        this.replaySampleRate = config.replaySampleRate ?? this.replaySampleRate;
        this.replayDefaultMasking = config.replayDefaultMasking ?? this.replayDefaultMasking;
        this.supportReactRouter = config.supportReactRouter ?? this.supportReactRouter;

        datadogRum.init({
            applicationId: config.applicationId,
            clientToken: config.clientToken,
            site: 'datadoghq.com', // DO NOT CHANGE
            service: config.serviceName,
            env: config.env,
            version: config.version,
            sessionSampleRate: this.sessionSampleRate,
            sessionReplaySampleRate: this.replaySampleRate,
            defaultPrivacyLevel: this.replayDefaultMasking,
            plugins: this.supportReactRouter ? [reactPlugin({ router: true })] : ([] as any),
        });

        if (this.replaySampleRate > 0) {
            datadogRum.startSessionReplayRecording();
        }

        this.isInited = true;
    }

    getReactRouter() {
        if (!this.supportReactRouter) {
            return createBrowserRouterReact;
        } else {
            return createBrowserRouterRUM;
        }
    }
}

export default new DatadogRUM();
